import { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import {
  faCaretDown,
  faCaretUp,
  faEye,
  faMessage,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  baseURL,
  DELETELESSONS,
  DELETEMESSAGE,
  STUDENTQUEREY,
} from "../../../API/API";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import {
  FaBook,
  FaComments,
  FaEnvelope,
  FaPhone,
  FaUser,
} from "react-icons/fa6";
import ResponsMessage from "./ResponsMessage";

export default function StudentQuery() {
  const [academicYears, setAcademicYears] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [Order, setOrder] = useState("username");
  const [OrderType, setOrderType] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkAction, setBulkAction] = useState("");
  const [showmessage, setShowMessage] = useState(false);
  const [rowId, setrowId] = useState([]);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showMessageCard, setShowMessageCard] = useState(false);
  const [selectedId, setSelectedID] = useState();
  const fetchData = useCallback(async () => {
    try {
      const res = await axiosPrivate.post(`${baseURL}/${STUDENTQUEREY}`, {
        Order,
        OrderType,
        indexpage,
      });

      console.log("Student Queries Data:", res.data);
      setAcademicYears(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error("خطأ في جلب استعلامات الطلاب:", err);
      setAcademicYears([]);
    }
  }, [axiosPrivate, Order, OrderType, indexpage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  async function deleteItems(selectedIds) {
    try {
      const res = await axiosPrivate.delete(`${baseURL}/${DELETEMESSAGE}`, {
        data: { ids: selectedIds },
      });
      fetchData();
    } catch (err) {
      console.log(err);
    }
  }

  //1/ في الـ state
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedContactMsg, setSelectedContactMsg] = useState(null);

  const handleShowModal = (rowData) => {
    setSelectedContactMsg(rowData);
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setSelectedContactMsg(null);
  };

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center mb-5">
        <h4 className="fw-bold"> استفسارات الطلاب</h4>
      </div>

      {/* Filters */}
      <div className="d-flex mb-3 gap-2 flex-wrap">
        <Form.Select
          style={{ maxWidth: "240px" }}
          onChange={(e) => setBulkAction(e.target.value)}
        >
          <option value="">تنفيذ على العناصر المحددة</option>
          <option value="delete">حذف</option>
        </Form.Select>

        <Button
          className="custom-brand-btn-dhash"
          variant="secondary"
          onClick={() => {
            if (selectedItems.length > 0) {
              setShowMessage(true);
            }
          }}
        >
          تطبيق
        </Button>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              {/* UP and down */}
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span>الاسم</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "lessonName");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "lessonName");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <span> الدرس</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "lessonDescription");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "lessonDescription");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> الرسالة </span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "academicYear");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "academicYear");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>

              <th>أدوات</th>

              <th>*</th>
            </tr>
          </thead>
          <tbody>
            {academicYears.map((row, index) => (
              <tr key={index}>
                <td>{row.username}</td>
                <td>{row.lessonName}</td>
                <td>{row.message}</td>

                <td className="d-flex justify-content-center gap-2">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>حذف</Tooltip>}
                  >
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => {
                        setrowId([row.id]);
                        setShowMessage(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>رد</Tooltip>}
                  >
                    <Button
                      onClick={() => {
                        setShowMessageCard(true);
                        setSelectedID(row.id);
                      }} //1/ هنا بنبعت بيانات الصف
                      size="sm"
                      variant="outline-info"
                    >
                      <FontAwesomeIcon
                        icon={faMessage}
                        style={{ color: "var(--brand-200)" }}
                      />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>عرض</Tooltip>}
                  >
                    <Button
                      onClick={() => handleShowModal(row)} //1/ هنا بنبعت بيانات الصف
                      size="sm"
                      variant="outline-info"
                    >
                      <FontAwesomeIcon
                        icon={faEye}
                        style={{ color: "#17A2B8" }}
                      />
                    </Button>
                  </OverlayTrigger>
                </td>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedItems.includes(row.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedItems((prev) => [...prev, row.id]);
                      } else {
                        setSelectedItems((prev) =>
                          prev.filter((id) => id !== row.id)
                        );
                      }
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Pagination
        className="justify-content-center custom-pagination"
        dir="ltr"
      >
        <Pagination.Prev
          onClick={() => {
            if (indexpage > 1) setindexPage(indexpage - 1);
          }}
          disabled={indexpage === 1}
        />

        {[...Array(totalPages).keys()]
          .map((n) => n + 1)
          .filter(
            (page) =>
              page === 1 ||
              page === totalPages ||
              (page >= indexpage - 2 && page <= indexpage + 2)
          )
          .map((page, i, arr) => {
            const prevPage = arr[i - 1];
            if (prevPage && page - prevPage > 1) {
              return [
                <Pagination.Ellipsis key={`ellipsis-${page}`} disabled />,
                <Pagination.Item
                  key={page}
                  active={indexpage === page}
                  onClick={() => setindexPage(page)}
                >
                  {page}
                </Pagination.Item>,
              ];
            }

            return (
              <Pagination.Item
                key={page}
                active={indexpage === page}
                onClick={() => setindexPage(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

        <Pagination.Next
          onClick={() => {
            if (indexpage < totalPages) setindexPage(indexpage + 1);
          }}
          disabled={indexpage === totalPages}
        />
      </Pagination>

      {showmessage && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              ستقوم بحذف العناصر المحددة
            </h2>
            <div>
              <p>لن تتمكن من التراجع عن هذا الإجراء.</p>
              <p></p>
            </div>

            <div className="d-flex justify-content-start gap-3 ">
              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  if (rowId.length > 0) {
                    deleteItems(rowId);
                    setrowId([]);
                  }

                  setShowMessage(false);
                  if (bulkAction === "delete") {
                    deleteItems(selectedItems);
                  }
                }}
              >
                تاكيد الحذف
              </button>

              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  setShowMessage(false);
                }}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        show={showContactModal}
        onHide={handleCloseContactModal}
        centered
        dir="ltr"
      >
        <Modal.Header className="position-relative border-0">
          <Modal.Title className="fw-bold fs-5">
            تفاصيل رسالة التواصل
          </Modal.Title>

          <Button
            variant="danger"
            onClick={handleCloseContactModal}
            className="position-absolute top-0 end-0 me-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "32px",
              height: "32px",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            ×
          </Button>
        </Modal.Header>
        <Modal.Body>
          {selectedContactMsg ? (
            <div
              className="p-3 border rounded bg-light"
              style={{ lineHeight: "2", direction: "rtl" }}
            >
              <p>
                <strong>
                  <FaUser size={20} className="me-2" /> الاسم:
                </strong>{" "}
                {selectedContactMsg.username}
              </p>
              <p>
                <strong>
                  <FaBook size={20} className="me-2" /> الدرس:
                </strong>{" "}
                {selectedContactMsg.lessonName || "غير متوفر"}
              </p>
              <p>
                <strong>
                  <FaComments size={20} className="me-2" /> الرسالة:
                </strong>
              </p>
              <div className="border rounded p-3 bg-white">
                {selectedContactMsg.message}
              </div>
            </div>
          ) : (
            <div className="text-center text-muted p-4">
              لا توجد بيانات لعرضها حاليًا
            </div>
          )}
        </Modal.Body>
      </Modal>

      {showMessageCard && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          onClick={() => setShowMessageCard(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <ResponsMessage
              setmessage={setShowMessageCard}
              message={showMessageCard}
              selectId={selectedId}
              onSuccess={() => {
                // إعادة تحميل البيانات بعد الرد بنجاح
                fetchData();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
